'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIGrid = require('../grid/UIGrid');

var _UIGrid2 = _interopRequireDefault(_UIGrid);

var _UIGridItem = require('../grid/UIGridItem');

var _UIGridItem2 = _interopRequireDefault(_UIGridItem);

var _UIMain = require('../layout/UIMain');

var _UIMain2 = _interopRequireDefault(_UIMain);

var _customRenderer = require('../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mainSectionGridSize(sidebarComponent) {
  var gridSize = sidebarComponent ? { xs: 12, sm: 8, md: 8, lg: 9, xl: 10 } : { xs: 12 };
  return gridSize;
}

function getSidebarClassName(_ref) {
  var sidebarAtBottom = _ref.sidebarAtBottom;

  return (0, _reactUtils.classNames)('private-template__sidebar', {
    'private-template__sidebar--bottom': sidebarAtBottom
  });
}

function renderSidebar(sidebar, sidebarAtBottom) {
  if (!sidebar) return null;

  return _react2.default.createElement(
    _UIGridItem2.default,
    {
      className: getSidebarClassName({ sidebarAtBottom: sidebarAtBottom }),
      size: { xs: 12, sm: 4, md: 4, lg: 3, xl: 2 }
    },
    CustomRenderer.render(sidebar)
  );
}

exports.default = _react2.default.createClass({
  displayName: 'UIAbstractPageGridContent',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    children: _react.PropTypes.node,
    moveSidebarToBottom: _react.PropTypes.bool,
    sidebarComponent: CustomRenderer.propType
  },

  getInitialState: function getInitialState() {
    return {
      sidebarAtBottom: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.checkNeedToMoveSidebar();
    window.addEventListener('resize', this.checkNeedToMoveSidebar);
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('resize', this.checkNeedToMoveSidebar);
  },
  checkNeedToMoveSidebar: function checkNeedToMoveSidebar() {
    var smallBreakpoint = parseInt(_sizes.GRID_BREAKPOINT_SMALL, 10);
    var toMoveSidebar = window.matchMedia('(max-width: ' + (smallBreakpoint - 1) + 'px)').matches;
    var moveSidebarToBottom = this.props.moveSidebarToBottom;

    if (moveSidebarToBottom && toMoveSidebar !== this.state.sidebarAtBottom) {
      this.setState({ sidebarAtBottom: toMoveSidebar });
    }
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        sidebarComponent = _props.sidebarComponent;
    var sidebarAtBottom = this.state.sidebarAtBottom;


    return _react2.default.createElement(
      _UIGrid2.default,
      null,
      renderSidebar(sidebarComponent, sidebarAtBottom),
      _react2.default.createElement(
        _UIGridItem2.default,
        { size: mainSectionGridSize(sidebarComponent) },
        _react2.default.createElement(
          _UIMain2.default,
          { flush: true },
          children
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/page/UIAbstractPageGridContent.js
// module id = 368
// module chunks = 0